module.exports = __webpack_public_path__ + "img/9791158882884.6d53df19.jpg";